import * as React from 'react'

import { IconButton } from '~/sotano-kit/primitives/icon-button'
import { Action } from '../utils'
import { debounce } from 'lodash'

export const Editor = ({
  children,
  allowedMimeTypes,
  isEmpty,
  isHiglighted = false,
  actions,
  inputId,
  onChange,
  onFinishedEditing,
}: {
  children?: React.ReactNode
  allowedMimeTypes: string[] | undefined
  isEmpty: boolean
  isHiglighted?: boolean
  actions: Action[]
  inputId: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  onFinishedEditing: () => void
}) => {
  const inputRef = React.useRef<HTMLInputElement>(null)

  React.useEffect(() => {
    if (!isEmpty || !isHiglighted) return

    debounce(() => {
      if (inputRef.current) {
        inputRef.current.click()
      }
    }, 1000)
  }, [isHiglighted, isEmpty])

  return (
    <div
      style={{ fontSize: 'var(--gdg-editor-font-size)' }}
      className="relative flex-1 text-dark-muted"
    >
      {children}
      <div className="absolute flex items-center top-0 right-0 gap-x-1">
        {actions.map((action, index) => {
          return (
            <IconButton
              key={index}
              onClick={() => {
                if (!inputRef.current) return
                action.onClick?.(inputRef.current, onFinishedEditing)
              }}
              className="w-6 h-6 border-dark-border-solid border hover:border-dark-border-elevated bg-dark-shade rounded-md text-dark-bright"
            >
              {action.icon}
            </IconButton>
          )
        })}
      </div>

      <input
        ref={inputRef}
        id={inputId}
        className="min-h-[26px] border-none outline-none bg-transparent hidden"
        type="file"
        required
        autoFocus
        accept={allowedMimeTypes?.join(',')}
        onChange={onChange}
      />
    </div>
  )
}
